import { styled, Box } from "@mui/material";
import { SIGNUP_COLORS } from "../../pages/public/SignUp/tokens";

export const AuthLeftPanelContainer = styled(Box)(() => ({
  position: "relative",
  height: "100%",
  width: "100%",
  overflow: "hidden",
  backgroundColor: SIGNUP_COLORS.backgroundGradient,
}));

export const AuthLeftPanelOverlay = styled(Box)(() => ({
  position: "absolute",
  inset: 0,
  zIndex: 2,
  background: `linear-gradient(to right, ${SIGNUP_COLORS.backgroundGradient}E6 0%, ${SIGNUP_COLORS.backgroundGradient}99 40%, ${SIGNUP_COLORS.primary}80 100%)`,
  opacity: 0.85,
}));

export const AuthLeftPanelContent = styled(Box)(() => ({
  position: "relative",
  height: "100%",
  width: "100%",
  zIndex: 3,
}));
